<template>
  <form @submit.prevent="submit">
    <sweet-input v-model="form.name" :isValid="!$v.form.name.$error" @input="$v.form.name.$touch()" layout="vertical" :label="$t('firm.admin.name')" />
    <sweet-input class="mt-2" v-model="form.email" :isValid="!$v.form.email.$error" @input="$v.form.email.$touch()" layout="vertical" :label="$t('firm.admin.email')" />
    <sweet-input class="mt-2" v-model="form.phone" :isValid="!$v.form.phone.$error" @input="$v.form.phone.$touch()" layout="vertical" :label="$t('firm.admin.phone')" />
    <div class="text-right mt-3">
      <sweet-button type="submit" :loading="isSubmitting" :disabled="isSubmitting || $v.$invalid" variant="success" icon="mdi mdi-send" size="sm">
        {{ $t("common.invite") }}
      </sweet-button>
    </div>
  </form>
</template>

<script>
import SweetButton from "@c/form/sweet-button.vue";
import SweetInput from "@c/form/sweet-input.vue";
import { email, maxLength, minLength, required } from "vuelidate/lib/validators";

export default {
  name: "FirmAdminInvite",
  components: { SweetInput, SweetButton },
  props: {
    firm: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      isSubmitting: false,
      form: {
        name: "",
        email: "",
        phone: "",
      },
    };
  },
  validations: {
    form: {
      name: {
        required,
        minLength: minLength(1),
        maxLength: maxLength(350),
      },
      email: {
        required,
        email,
      },
      phone: {
        maxLength: maxLength(50),
      },
    },
  },
  methods: {
    async submit() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }
      this.isSubmitting = true;
      try {
        await this.$store.dispatch("organizationFirm/inviteAdmin", {
          firm: this.firm,
          invite: { ...this.form },
        });
        this.$toast.success(this.$t("firm.admin.invite-success"));
        this.form = { name: "", email: "", phone: "" };
        this.$v.$reset();
        this.$emit("success");
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
      } finally {
        this.isSubmitting = false;
      }
    },
  },
};
</script>
